import 'src/vendor/slick/slick.js'
import 'src/users.js'

import Rails from 'rails-ujs';
const myCustomContext = require.context("components", true);
const ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(myCustomContext);
Rails.start();
